import React, { Component } from "react"

/* Settings */
const SIZE = 90
const STROKE = 12
const RADIUS = (SIZE - STROKE) / 2
const LENGTH = 2 * Math.PI * RADIUS
const PATH = `m ${SIZE / 2},${STROKE / 2} a ${RADIUS},${RADIUS} 0 1,1 0,${2 * RADIUS} a ${RADIUS},${RADIUS} 0 1,1 0,-${2 * RADIUS}`
const TRAIL = "rgba(0, 0, 0, 0.2)"
const COLORS = [[68, 139, 3], [219, 165, 4], [162, 1, 1]]


class Timer extends Component {

    constructor(props) {
        super(props)

        this.state = {
            endTime: 0,
            duration: 0,
            seconds: 0,
        }

        this._frame = null
        this._path = null
    }

    componentDidMount = () => {
        document.addEventListener("visibilitychange", this.tick)
    }

    componentDidUpdate = (prevProps) => {

        /* Reset when choice stage is over */
        if (prevProps.active !== false && this.props.active === false && this.state.duration) {
            this.stop()
        }
    }

    componentWillUnmount = () => {
        document.removeEventListener("visibilitychange", this.tick)
        this.cancel()
    }

    /* Start Action */
    start = (duration = 10) => {

        const d = parseInt(duration, 10)

        if (!Number.isFinite(d) || d <= 0) {
            this.stop()
            return
        }

        this.cancel()
        this.setState({ endTime: Date.now() + d * 1000, duration: d, seconds: d }, this.tick)
    }

    /* Stop Action */
    stop = () => {
        this.cancel()
        this.setState({ endTime: 0, duration: 0, seconds: 0 })
    }

    /* Cancel Animation Frame */
    cancel = () => {
        if (this._frame) {
            cancelAnimationFrame(this._frame)
            this._frame = null
        }
    }

    /* Get Color by remaining time */
    color = (remaining, duration) => {

        const half = duration / 2
        const [from, to, progress] = remaining >= half
            ? [COLORS[1], COLORS[0], half > 0 ? (remaining - half) / half : 1]
            : [COLORS[2], COLORS[1], half > 0 ? remaining / half : 0]

        const rgb = from.map((value, index) => Math.round(value + (to[index] - value) * progress))

        return `rgb(${rgb.join(", ")})`
    }

    /* Animation Tick */
    tick = () => {

        const { endTime, duration, seconds } = this.state

        this.cancel()

        if (!endTime || !duration) {
            return
        }

        const remaining = Math.max(0, (endTime - Date.now()) / 1000)

        /* Update Ring directly (no re-render on every frame) */
        if (this._path) {
            this._path.style.strokeDashoffset = `${LENGTH * (1 - remaining / duration)}`
            this._path.style.stroke = this.color(remaining, duration)
        }

        /* Finish */
        if (remaining <= 0) {
            this.stop()
            return
        }

        /* Update Seconds */
        const current = Math.ceil(remaining)
        if (current !== seconds) {
            this.setState({ seconds: current })
        }

        this._frame = requestAnimationFrame(this.tick)
    }

    render = () => {

        const { active = true } = this.props
        const { duration, seconds } = this.state

        if (!active || !duration) {
            return <div className="mpb--timer hidden" />
        }

        return (
            <div className="mpb--timer visible">
                <div className="mpb--timer-circle" style={{ width: SIZE, height: SIZE }}>
                    <svg width={SIZE} height={SIZE} viewBox={`0 0 ${SIZE} ${SIZE}`} xmlns="http://www.w3.org/2000/svg">
                        <path d={PATH} fill="none" stroke={TRAIL} strokeWidth={STROKE} />
                        <path
                            ref={(ref) => this._path = ref}
                            d={PATH}
                            fill="none"
                            stroke={this.color(seconds, duration)}
                            strokeWidth={STROKE}
                            strokeLinecap="round"
                            strokeDasharray={LENGTH}
                            strokeDashoffset={0}
                        />
                    </svg>
                    <div className="mpb--timer-text">{seconds}</div>
                </div>
            </div>
        )
    }
}

export default Timer
